import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

import { FormSection } from '../formSection/FormSection'
import { AddNewProgramFormModel } from '../AddNewProgram.types'

import { FormField, TextInput } from '@percent/lemonade'
import { AllowedOrganisationTypes } from './allowedOrganisationTypes/AllowedOrganisationTypes'
import { DisallowedOrganisations } from './disallowedOrganisations/DisallowedOrganisations'
import { Checks } from './checks/Checks'
import { DynamicValidationSubmissionStatus } from './checks/dynamicValidationSubmissionStatus/DynamicValidationSubmissionStatus'

export function Configuration() {
  const { t } = useTranslation()

  const {
    register,
    formState: { errors, dirtyFields }
  } = useFormContext<AddNewProgramFormModel>()

  return (
    <FormSection title={t('form.configuration')}>
      <FormField
        label={t('form.nameOfTheProgram')}
        status={errors.programName?.message && dirtyFields.programName ? 'danger' : 'default'}
        statusMessage={errors.programName?.message}
      >
        <TextInput {...register('programName')} placeholder={t('form.nameOfTheProgramPlaceholder')} />
      </FormField>
      <AllowedOrganisationTypes />
      <DisallowedOrganisations />
      <Checks />
      <DynamicValidationSubmissionStatus />
    </FormSection>
  )
}
